export default "__VITE_ASSET__dae1c000__"